var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10L8.73303 9.6179C9.49118 9.2227 10.3765 9.14924 11.1894 9.41408L12.0022 9.67889C12.6427 9.88757 13.333 9.88757 13.9735 9.67889L15.0018 9.34388C15.6853 9.12121 16.424 9.13653 17.0976 9.38736L17.8622 9.67204C18.4372 9.88611 19.0617 9.9294 19.6607 9.79671L21 9.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04883 18.3333L9.23218 18.2183C9.75398 17.8911 10.4 17.8307 10.9735 18.0554V18.0554C11.4292 18.2341 11.9357 18.2341 12.3915 18.0554L12.5191 18.0054C13.0206 17.8089 13.5801 17.8222 14.0718 18.0424V18.0424C14.4919 18.2306 14.9641 18.2686 15.409 18.15L15.913 18.0157",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7229 13.5884L12.0311 13.4467C12.7234 13.1283 13.507 13.069 14.2393 13.2794L14.4353 13.3358C15.0096 13.5008 15.6188 13.5008 16.1931 13.3358L16.5829 13.2237C17.1963 13.0474 17.8485 13.0597 18.4548 13.2588L18.6695 13.3293C19.1865 13.4992 19.7385 13.5336 20.2727 13.4292L21.0831 13.2708",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22L7.15589 21.4778C7.83898 21.1692 8.60909 21.1117 9.33044 21.3154L10.8906 21.7559C11.456 21.9155 12.0545 21.9155 12.6198 21.7559L14.3709 21.2615C14.9747 21.091 15.6155 21.1028 16.2126 21.2955L17.6197 21.7495C18.1289 21.9139 18.6713 21.9471 19.1968 21.8462L21 21.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrents);
export default __webpack_public_path__ + "static/media/currents.fe0b410f0b49b387f51053cecbe3e843.svg";
export { ForwardRef as ReactComponent };